import React from 'react'
import theme from 'redesign/themes/main'
import SvgWrapper from '../SvgWrapper'
import { ICON_SIZE, ICON_VIEWBOX } from './constants'
import type { IconProps } from './types'

const InfoCircleIcon: React.FC<IconProps> = ({
  color = theme.palette.error.main,
  size = ICON_SIZE.medium,
  viewBox = ICON_VIEWBOX.medium,
  fillOpacity,
  isFilled = false,
}) => {
  const path = isFilled ? (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 22c5.5227 0 10-4.4773 10-10 0-5.52269-4.4773-10-10-10C6.47731 2 2 6.47731 2 12c0 5.5227 4.47731 10 10 10Zm-.8586-14.44452c.1956-.19559.4609-.30548.7375-.30548.2766 0 .5419.10989.7375.30548.1956.19559.3055.46087.3055.73749 0 .27661-.1099.5419-.3055.73749-.1956.19559-.4609.30548-.7375.30548-.2766 0-.5419-.10989-.7375-.30548-.1956-.19559-.3055-.46088-.3055-.73749 0-.27662.1099-.5419.3055-.73749ZM10.25 10.9297c0-.4142.3358-.75.75-.75h.5859c.3544 0 .6942.1407.9447.3913.2505.2505.3913.5903.3913.9446v2.9297c0 .1119.0444.2192.1235.2983.0792.0791.1865.1236.2984.1236h.5859c.4142 0 .75.3358.75.75s-.3358.75-.75.75h-.5859c-.5098 0-.9986-.2025-1.359-.5629-.3604-.3604-.5629-.8493-.5629-1.359v-2.7656H11c-.4142 0-.75-.3358-.75-.75Z"
      fill={color}
      fillOpacity={fillOpacity}
    />
  ) : (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 22c5.5227 0 10-4.4773 10-10 0-5.52269-4.4773-10-10-10C6.47731 2 2 6.47731 2 12c0 5.5227 4.47731 10 10 10Zm0-1.5c4.6943 0 8.5-3.8057 8.5-8.5 0-4.69427-3.8057-8.5-8.5-8.5-4.69427 0-8.5 3.80573-8.5 8.5 0 4.6943 3.80573 8.5 8.5 8.5Zm-.8586-12.94452c.1956-.19559.4609-.30548.7375-.30548.2766 0 .5419.10989.7375.30548.1956.19559.3055.46087.3055.73749 0 .27661-.1099.5419-.3055.73749-.1956.19559-.4609.30548-.7375.30548-.2766 0-.5419-.10989-.7375-.30548-.1956-.19559-.3055-.46088-.3055-.73749 0-.27662.1099-.5419.3055-.73749ZM10.25 10.9297c0-.4142.3358-.75.75-.75h.5859c.3544 0 .6942.1407.9447.3913.2505.2505.3913.5903.3913.9446v2.9297c0 .1119.0444.2192.1235.2983.0792.0791.1865.1236.2984.1236h.5859c.4142 0 .75.3358.75.75s-.3358.75-.75.75h-.5859c-.5098 0-.9986-.2025-1.359-.5629-.3604-.3604-.5629-.8493-.5629-1.359v-2.7656H11c-.4142 0-.75-.3358-.75-.75Z"
      fill={color}
      fillOpacity={fillOpacity}
    />
  )

  return (
    <SvgWrapper aria-label="InfoCircleIcon" size={size} viewBox={viewBox} fill="none">
      {path}
    </SvgWrapper>
  )
}

export default InfoCircleIcon
